import { Typography, Row } from "antd";

const { Title, Paragraph } = Typography;

export default function SearchSection({ searchTerm, children, totalResults }) {
  if (!searchTerm) {
    return null;
  }

  return (
    <section style={{ marginBottom: "64px", marginTop: "0px" }}>
      <div
        style={{
          marginBottom: "8px",
          paddingTop: "1px",
        }}
      >
        <Title level={2}>Search Results for "{searchTerm}"</Title>
        {totalResults !== undefined && (
          <Paragraph style={{ color: "#666", marginBottom: "24px" }}>
            Found {totalResults} matching results
          </Paragraph>
        )}
      </div>
      <Row gutter={[24, 24]}>{children}</Row>
    </section>
  );
}
